import React, { useEffect, useState } from "react";
import "./Home.css";

const Home = () => {
  const villageName = "";

  const heroImages = [
    "/images/slide1.jpeg",
    "/images/slide2.jpeg",
    "/images/slide3.jpeg",
    "/images/slide4.jpeg",
  ];

  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroImages.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [heroImages.length]);

  // ===== Leader Data =====
  const sarpanch = {
    name: "श्री.राजेंद्र वसंत वैती ",
    phone: 9545174890,
    photo: "/images/sarpanch.jpeg",
  };

  const upsarpanch = {
    name: "श्री.योगेश चंद्रकांत तरे ",
    photo: "/images/upsarpanch.jpeg",
  };

  const sachiv = {
    name: "श्री.महेश रमाकांत किणी",
    photo: "/images/sachiv.jpeg",
  };

  // ===== Maharashtra Leaders =====
  const maharashtraLeaders = [
    { name: " श्री. देवेंद्र फडणवीस (माननीय मुख्यमंत्री महोदय)", photo: "/images/cm.jpg" },
    { name: "श्री एकनाथ शिंदे (माननीय उपमुख्यमंत्री)", photo: "/images/eknath.jpg" },
    { name: "सौ सुनैत्रा पवार (माननीय उपमुख्यमंत्री)", photo: "/images/sunetra.jpeg" },
    { name: "श्री योगेश कदम (मा. राज्यमंत्री, ग्रामविकास व पंचायत राज विभाग)", photo: "/images/yogesh.jpeg" },
    { name: "श्री जयकुमार गोरे (मा. मंत्री, ग्रामविकास व पंचायत राज विभाग)", photo: "/images/gore.jpg" },
    { name: "श्री गणेश नाईक (मा. वनमंत्री व पालघर जिल्ह्याचे पालकमंत्री)", photo: "/images/ganesh.png" },
    { name: "श्री हेमंत सवरा (खासदार, पालघर लोकसभा)", photo: "/images/hemant.jpg" },
    { name: "श्री विलास तरे (आमदार, बोईसर विधानसभा)", photo: "/images/vilas.jpg" },
    { name: "श्री मनोज रानडे (मुख्य कार्यकारी अधिकारी, जिल्हा परिषद पालघर)", photo: "/images/manoj.jpg" },
    { name: "श्री रविंद्र शिंदे (मा. अति. मुख्य कार्यकारी अधिकारी जिल्हा परिषद पालघर)", photo: "/images/ravindra.jpg" },
    { name: "श्री अशोक पाटील (उपमुख्य कार्यकारी अधिकारी (पंचायत) जिल्हा परिषद पालघर)", photo: "/images/ashok.jpg" },
    { name: "श्री संजय भोये (गट विकास अधिकारी (निवड श्रेणी), पंचायत समिती पालघर)", photo: "/images/bhoye.jpg" },
  ];

  const members = [
    { sr: 1, name: "श्री. प्रभाकर यशवंत ठाकूर", ward: "सदस्य", phone: "9224635239" },
    { sr: 2, name: "श्री.हरेश रमाकांत किनरे", ward: "सदस्य", phone: "70837 96236" },
    { sr: 3, name: "श्री. भूपेश माणिक मोरे", ward: "सदस्य", phone: "9272280615" },
    { sr: 4, name: "श्रीम. कामिनी सुरेश तरे ", ward: "सदस्य", phone: "74991 59770" },
    { sr: 5, name: "श्रीम. समिक्षा अक्षय सुमडा ", ward: "सदस्य", phone: "79723 03268" },
    { sr: 6, name: "सौ. अस्मिता संतोष राऊत", ward: "सदस्य", phone: "92267 29872" },
    { sr: 7, name: "श्रीम. ज्योत्स्ना रविंद्र रजवाडी", ward: "सदस्य", phone: "92264 19294" },
    { sr: 8, name: "श्री. निलेश रमेश किणी", ward: "सदस्य", phone: "97646 04302" },
    { sr: 9, name: " श्रीम. प्रतीक्षा प्रदीप तरे", ward: "सदस्य", phone: "77560 98766" },
    { sr: 10, name: " श्रीम. तृप्ती भूपेंद्र तरे ", ward: "सदस्य", phone: "9923079417" }, 
  ];

  const SafeImage = ({ src, alt }) => {
    const fallback = "https://via.placeholder.com/300x300/D3D3D3/666666?text=फोटो+नाही";
    const [img, setImg] = useState(src);

    return (
      <img
        src={img}
        alt={alt}
        onError={() => setImg(fallback)}
        style={{ width: "100%", height: "100%", objectFit: "cover" }}
      />
    );
  };

  return (
    <div className="home-container">

      {/* ===== Marquee ===== */}
      <div className="marquee-wrapper">
        <div className="marquee">
          ग्रामपंचायत एडवण | पंचायत समिती पालघर, जि. पालघर | संपर्क:- 9545174890
        </div>
      </div>

      {/* ===== Hero Section ===== */}
<section className="hero">
  {heroImages.map((img, i) => (
    <div
      key={i}
      className={`hero-slide ${currentSlide === i ? "active" : ""}`}
      style={{ backgroundImage: `url(${img})` }}
    />
  ))}
  <div className="hero-overlay">
    <div className="hero-content">
      <h1>ग्रामपंचायत "एडवण" आपले स्वागत आहे {villageName}</h1>
      <p>आमच्या गावाचा सर्वांगीण विकास हेच आमचे ध्येय!</p>
      <a href="/aboutus">अधिक माहिती</a>
    </div>
  </div>
</section>

{/* ===== Maharashtra Leaders Section (NEW) ===== */}
<section className="section">
  <h2 className="title">महाराष्ट्र नेतृत्व</h2>

  <div className="leaders-grid">
    {maharashtraLeaders.map((leader, index) => (
      <div className="leader-card" key={index}>
        <div className="leader-img">
          <SafeImage src={leader.photo} alt={leader.name} />
        </div>
        <p>{leader.name}</p>
      </div>
    ))}
  </div>
</section>

      {/* ===== Leaders Section ===== */}
      <section className="section">
        <h2 className="title">ग्रामपंचायत प्रतिनिधी</h2>
        <div className="layout">

          <div className="leaders">
            <div className="leader-card sarpanch-card">
              <div className="leader-img">
                <SafeImage src={sarpanch.photo} alt="सरपंच" />
              </div>
              <h3>सरपंच</h3>
              <b>{sarpanch.name}</b>
            </div>

            <div className="leader-card upsarpanch-card">
              <div className="leader-img">
                <SafeImage src={upsarpanch.photo} alt="उपसरपंच" />
              </div>
              <h3>उपसरपंच</h3>
              <b>{upsarpanch.name}</b>
            </div>

            <div className="leader-card sachiv-card">
              <div className="leader-img">
                <SafeImage src={sachiv.photo} alt="सचिव" />
              </div>
              <h3>ग्रामपंचायत अधिकारी</h3>
              <b>{sachiv.name}</b>
            </div>
          </div>

          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>अ.क्र.</th>
                  <th>सदस्याचे नाव</th>
                  <th>पद</th>
                  <th>संपर्क</th>
                </tr>
              </thead>
              <tbody>
                {members.map((m) => (
                  <tr key={m.sr}>
                    <td>{m.sr}</td>
                    <td>{m.name}</td>
                    <td>{m.ward}</td>
                    <td>{m.phone}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

        </div>
      </section>


      {/* ===== Map Section ===== */}
      <section className="map-section">
        <h2 className="map-title">📍 ग्रामपंचायत एडवण – स्थान</h2>
        <p className="map-subtitle">ग्रामपंचायत एडवण, तालुका पालघर, जिल्हा पालघर</p>
        <div className="map-container">
          <iframe
            title="Edvan Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7637.32498878761!2d72.72749649999999!3d19.54531225!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be701c5f4b0dfab%3A0xbdbfa9942d328f3e!2sEdvan%2C%20Maharashtra%20401102!5e1!3m2!1sen!2sin!4v1772086107010!5m2!1sen!2sin"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
      </section>

    </div>
  );
};

export default Home;